<template>
  <div id="app">
    <mobileNavBar v-if="classObj"></mobileNavBar>
    <div :class="[classObj, 'common-div', barStatus]" class="app-wrapper">
      <high-header />
      <div class="container">
        <router-view/>
      </div>
      <high-footer />
    </div>
  </div>
</template>

<script>
import HighHeader from '@/components/headerComp/high-header.vue'
import HighFooter from '@/components/footerComp/high-footer.vue'
import mobileNavBar from './components/mobileNavBar'
import ResizeMixin from '../mixin/ResizeHandler'
export default {
  name: 'App',
  mixins: [ResizeMixin],
  computed: {
    device(){
      return this.$store.state.app.device
    },
    classObj(){
      return {
        mobile: this.device === 'mobile'
      }
    },
    barStatus(){
      return {
        active: this.$store.state.app.showMobileStatus === true
      }
    }
  },
  mounted() {
  },
  components: {
    HighHeader,
    HighFooter,
    mobileNavBar
  }
}
</script>

<style lang="scss" scoped>
#app{
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    background-color: #FAFAFA;
  }
  .active{
    left: p2r(260px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue